import React from 'react';
import clsx from "clsx";
import PropTypes from "prop-types";

import Switch from "../../../../components/AssetModal/components/Switch";
import WarningTooltip from "../../../../components/WarningTooltip";

import useStyles from './styles';


function AggregatedDepotsSwitch({value, onChange, title="kumuliert", disabled, tooltip, flexDirection='row'}) {

  const classes = useStyles({flexDirection});

  return (
    <p className={clsx(classes.container, disabled && 'disabled')}>
      <Switch
        value={value}
        handleValueChanged={onChange}
        disabled={disabled}
        showLabel={false}
        customClasses={{
          container: classes.aggregatePortfoliosSwitchContainer,
          thumb: classes.aggregatePortfoliosSwitchThumb,
          checked: classes.aggregatePortfoliosSwitchChecked,
        }}
      />
      <span>{title}</span>
      {tooltip && (
        <WarningTooltip title={tooltip} />
      )}
    </p>
  )
}

AggregatedDepotsSwitch.propTypes = {
  labelPosition: PropTypes.oneOf(['row', 'row-reverse'])
}

AggregatedDepotsSwitch.propDefs = {}

export default AggregatedDepotsSwitch;